import z from 'zod';

export type SaveCarbonDioxideDto = {
	originLocationId: string;
	productionMethodId: string;
	value: number;
};

export const SaveCarbonDioxideDtoSchema: z.ZodType<SaveCarbonDioxideDto> = z.object({
	originLocationId: z.string(),
	productionMethodId: z.string(),
	value: z.number(),
});
